import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../store/redux/hooks'
import { PageIndex, setPageIndex } from '../../store/redux/reducers/pageNameSlice'
import NavigationTile from '../../components/Tile/NavigationTile'
import { AccessibilityNew, Construction, Settings, TextFields } from '@mui/icons-material'
import { Outlet, useNavigate } from 'react-router-dom'
import navigation from '../../config/navigation'
import { StyledContainerRowBetween } from '../../styles/ContainerStyles'
import { environment } from '../../enviroments/enviroment'

const AdminsPageView = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  // TILE SELECTION
  const [selectedIndex, setSelectedIndex] = useState(-1)

  useEffect(() => {
    dispatch(setPageIndex(PageIndex.ADMINS_PAGE))
    let path = window.location.pathname.replace(environment.publicUrl, '')

    if (path === navigation.adminSettings) {
      navigate(navigation.techStack)
    }

    const pathToIndexMap = {
      [navigation.general]: 0,
      [navigation.techStack]: 1,
      [navigation.accessibility]: 2,
      [navigation.dictionary]: 3,
    }

    if (pathToIndexMap.hasOwnProperty(path)) {
      setSelectedIndex(pathToIndexMap[path])
    }
  }, [navigate, dispatch])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        px: 2,
        bgcolor: 'background.dark',
        width: '100%',
        height: '100%',
        padding: { xs: '0px 0px', sm: '0px 16px' },
      }}
    >
      <StyledContainerRowBetween sx={{ gap: { xs: 1, xl: 4 }, height: 100, padding: { xs: '8px 0px', sm: '8px 8px' } }}>
        <NavigationTile
          icon={<Settings />}
          title={t('page.adminsPage.tiles.general.title')}
          subtitle={t('page.adminsPage.tiles.general.subtitle')}
          navigateTo={navigation.general}
          index={0}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <NavigationTile
          icon={<Construction />}
          title={t('page.adminsPage.tiles.techStack.title')}
          subtitle={t('page.adminsPage.tiles.techStack.subtitle')}
          navigateTo={navigation.techStack}
          index={1}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <NavigationTile
          icon={<AccessibilityNew />}
          title={t('page.adminsPage.tiles.accessibility.title')}
          subtitle={t('page.adminsPage.tiles.accessibility.subtitle')}
          navigateTo={navigation.accessibility}
          index={2}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
        <NavigationTile
          icon={<TextFields />}
          title={t('page.adminsPage.tiles.dictionary.title')}
          subtitle={t('page.adminsPage.tiles.dictionary.subtitle')}
          navigateTo={navigation.dictionary}
          index={3}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />
      </StyledContainerRowBetween>

      <Box sx={{ width: '100%', height: '100%' }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default AdminsPageView
